/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Scope_Library_ReadInputs */

const en_mcp_connect_scope_library_read = /** @type {(inputs: Mcp_Connect_Scope_Library_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find documents in your library and check their conversion status`)
};

const es_mcp_connect_scope_library_read = /** @type {(inputs: Mcp_Connect_Scope_Library_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar documentos en tu biblioteca y consultar el estado de su conversión`)
};

/**
* | output |
* | --- |
* | "Find documents in your library and check their conversion status" |
*
* @param {Mcp_Connect_Scope_Library_ReadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_scope_library_read = /** @type {((inputs?: Mcp_Connect_Scope_Library_ReadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Scope_Library_ReadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_scope_library_read(inputs)
	return en_mcp_connect_scope_library_read(inputs)
});